var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex-center flex-fill mt-5--5"},[_c('div',{staticClass:"d-flex align-items-center flex-column bg-white bg-opacity-75 p-4 fs-4"},[_c('span',{staticClass:"mb-3 text-center"},[_vm._v("Votre réponse a bien été prise en compte")]),_c('i',{staticClass:"fa-solid fa-circle-check fa-2xl text-success my-4"})])])
}]

export { render, staticRenderFns }